<template>
  <div>
    <div class="main">
      <h2>登録情報</h2>
      <div class="content">
        <h3>基本情報</h3>
        <ul>
          <li>
            <span>ユーザー名</span>
            <input type="text" class="input" v-model="userInfo.data.ddusername" disabled />
          </li>
          <li>
            <span>氏名</span>
            <input type="text" class="input" v-model="userInfo.data.realname" disabled />
          </li>
          <li class="xingbie">
            <span>性別</span>
            <input type="radio" name="xingbie" id :checked="userInfo.data.sex == 1" @change="
              userInfo.data.sex == 1
                ? (userInfo.data.sex = 0)
                : (userInfo.data.sex = 1)
              " />男
            <input type="radio" name="xingbie" id :checked="userInfo.data.sex == 0" @change="
              userInfo.data.sex == 1
                ? (userInfo.data.sex = 0)
                : (userInfo.data.sex = 1)
              " />女
          </li>
          <li>
            <span>メールアドレス</span>
            <input type="text" class="input" v-model="userInfo.data.email" disabled />
            <router-link to="/user/changPssword?type=email">編集</router-link>
          </li>
          <li>
            <span>サブアドレス</span>
            <input type="text" v-model="userInfo.data.related_email" class="input" />
            <a href="javascript:;" @click="sendCode" v-show="show">確認コードを取得</a>
            <a href="javascript:;" v-show="!show">{{ Countdown }}再送する</a>
          </li>
          <li v-show="showCode">
            <span>コード</span>
            <input type="text" v-model="code" class="input" style="width: 100px" />
            <a href="javascript:;" @click="saveUserRelatedEmail">保存</a>
          </li>
          <li>
            <span>電話</span>
            <input type="text" class="input" v-model="userInfo.data.tel" />
          </li>
          <li>
            <span>携帯電話</span>
            <input type="text" class="input" disabled v-model="userInfo.data.mobile" />
            <!-- <router-link to="changPssword">編集</router-link> -->
          </li>
        </ul>
        <!-- 是否已经注册1688 -->
        <div class="is1688" :class="{ relevance: relevance != false }">
          <p><img src="../../../assets/img/1688/1688.png" alt="">https://www.1688.com/</p>
          <p><img src="../../../assets/img/1688/taobao.png" alt="">https://www.taobao.com/</p>
          <p><img src="../../../assets/img/1688/tmall.png" alt="">https://www.tmall.com/</p>
          <div class="isRelevance">

            <router-link to="/accountSynchronization" target="_blank">
              <i class="el-icon-question"></i>
            </router-link>
            <span v-if="relevance == false" @click="$refs.synchronization1688.dialogVisible = true">今すぐ連結へ</span>
            <span v-else>連結済み</span>

          </div>
        </div>
        <h3>注目商品ジャンル</h3>
        <ol class="guanzhu">
          <li>
            <input type="checkbox" name id v-model="userInfo.data.fancys.fancy1" @change="fancy" />服・シューズ・バッグ ・腕時計
          </li>
          <li>
            <input type="checkbox" name id v-model="userInfo.data.fancys.fancy2" @change="fancy" />スポーツ＆アウトドア
          </li>
          <li>
            <input type="checkbox" name id v-model="userInfo.data.fancys.fancy3" @change="fancy" />手机周边
          </li>
          <li>
            <input type="checkbox" name id v-model="userInfo.data.fancys.fancy4" @change="fancy" />おもちゃ・ホビー
          </li>
          <li>
            <input type="checkbox" name id v-model="userInfo.data.fancys.fancy5" @change="fancy" />ホーム・ペット
          </li>
          <li>
            <input type="checkbox" name id v-model="userInfo.data.fancys.fancy6" @change="fancy" />パソコン・オフィス用品
          </li>
          <li>
            <input type="checkbox" name id v-model="userInfo.data.fancys.fancy7" @change="fancy" />照明器具
          </li>
          <li>
            <input type="checkbox" name id v-model="userInfo.data.fancys.fancy8" @change="fancy" />車＆バイク・産業・研究開発用品
          </li>
          <li>
            <input type="checkbox" name id v-model="userInfo.data.fancys.fancy9" @change="fancy" />家電・カメラ・AV機器
          </li>
        </ol>
        <h3>特に注意してほしいこと：</h3>
        <textarea name id cols="100" rows="8" v-model="userInfo.data.infoRemark"></textarea>
        <a href="javascript:;" class="baocun" @click="baocun">保存</a>
      </div>
    </div>
    <!-- 1688同步 -->
    <synchronization1688 ref="synchronization1688" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import synchronization1688 from '@/components/synchronization1688/synchronization1688'
import {
  updateUserInfo,
  sendCodeToEmail,
  saveUserRelatedEmail,
} from "../../../api/API/user";
import {
  alibabaUserRegisterList
} from "../../../api/API/login";

export default {
  components: {
    synchronization1688
  },
  data() {
    return {
      token: localStorage.getItem("token"),
      Countdown: 60,
      show: true,
      showCode: false,
      code: "",
      relevance: [],
    };
  },
  created() {
    this.alibabaUserRegisterList()
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    alibabaUserRegisterList() {
      alibabaUserRegisterList({ token: this.token }).then(res => {
        this.relevance = res.data

      })
    },
    fancy() {
      this.userInfo.data.fancy = "";
      for (var key in this.userInfo.data.fancys) {
        // console.log(this.userInfo.data.fancys[key]);
        if (this.userInfo.data.fancys[key] == true) {
          this.userInfo.data.fancy += key.charAt(key.length - 1) + ",";
        }
      }
    },
    // 发送验证码
    sendCode() {
      let isEmail =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      if (!isEmail.test(this.userInfo.data.related_email)) {
        return this.$message.error("メールアドレスを再確認ください。");
      }
      this.show = false;

      var timer = setInterval(() => {
        this.Countdown -= 1;
        if (this.Countdown <= 0) {
          this.show = true;
          this.Countdown = 60;
          clearInterval(timer);
        }
      }, 1000);
      let datas = {
        token: localStorage.getItem("token"),
        email: this.userInfo.data.related_email,
      };
      sendCodeToEmail(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.showCode = true;
      });
    },
    // 保存
    saveUserRelatedEmail() {
      let datas = {
        token: localStorage.getItem("token"),
        email: this.userInfo.data.related_email,
        code: this.code,
      };
      saveUserRelatedEmail(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.isEmail = false;
        this.show = true;
      });
    },
    baocun() {
      updateUserInfo(this.token, this.userInfo.data).then((res) => { });
      //
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;
  margin-bottom: 50px;

  h2 {
    height: 40px;
    background-color: #eee;
    color: #f3c622;
    line-height: 40px;
    padding-left: 20px;
    font-size: 20px;
  }

  .content {
    border: 1px solid #ccc;
    padding-top: 30px;
    padding-left: 110px;

    h3 {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 10px;
    }

    ul {
      li {
        height: 34px;
        line-height: 34px;
        margin-bottom: 20px;

        a {
          color: #f3c622;
          margin-left: 10px;

          &:hover {
            color: red;
          }
        }

        span {
          display: inline-block;
          width: 150px;
          text-align: right;
          margin-right: 30px;
          font-size: 12px;
          font-weight: 700;
        }

        .input {
          width: 350px;
          border: 1px solid #ccc;
          height: 32px;
          border-radius: 5px;
          font-size: 18px;
        }
      }

      .xingbie {
        input {
          width: 16px;
          height: 16px;
          margin: 0 5px 0 100px;
          vertical-align: middle;
        }
      }
    }

    .guanzhu {
      overflow: hidden;
      width: 800px;
      padding-left: 20px;

      li {
        float: left;
        font-size: 12px;
        height: 30px;
        line-height: 30px;
        font-weight: 700;
        width: 400px;

        input {
          width: 14px;
          height: 14px;
          vertical-align: middle;
        }
      }
    }

    .is1688 {
      padding: 40px 40px 20px 120px;
      background-color: #FEFAE6;
      border-radius: 3px;
      width: 600px;
      margin: 30px 0;
      position: relative;

      p {
        img {
          vertical-align: middle;
          margin-right: 30px;
        }

        font-size: 14px;
        margin-bottom: 18px;
      }

      .isRelevance {
        position: absolute;
        top: 50%;
        right: 130px;
        transform: translate(0, -50%);
        cursor: pointer;


        i {
          font-size: 20px;
          color: #DFDFDF;
          vertical-align: middle;
          margin-right: 5px;
        }

        font-size: 14px;
        color: #f3c622;
        text-decoration: underline;


      }

    }

    .relevance {
      background-color: #F5F5F5;

      .isRelevance {
        color: #50C136;
        text-decoration: underline;
      }
    }

    textarea {
      margin-left: 30px;
      font-size: 18px;
    }

    .baocun {
      display: block;
      width: 100px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: #f3c622;
      color: #fff;
      font-size: 16px;
      margin: 40px 0 30px 400px;
      border-radius: 10px;
    }
  }
}
</style>